import type { ChannelMarkupConditionType } from '@luxuryescapes/contract-svc-promo/channelMarkup';

/**
 * Condition types admins can create on a V2 channel markup. Shared by the editor and the
 * tester so a condition saved from the editor is never silently dropped during evaluation.
 */
export const CHANNEL_MARKUP_CREATABLE_CONDITION_TYPES = [
  'loyaltyOfferType',
  'offerId',
  'utmSource',
  'utmMedium',
  'utmCampaign',
  'utmTerm',
  'subscriberTier',
  'userRoleCondition',
  'luxPlusPrice',
  'packagePrice',
  'luxPlusSaving',
] as const satisfies ReadonlyArray<ChannelMarkupConditionType>;

export type ChannelMarkupCreatableConditionType = (typeof CHANNEL_MARKUP_CREATABLE_CONDITION_TYPES)[number];

export const isCreatableChannelMarkupConditionType = (
  conditionType: string,
): conditionType is ChannelMarkupCreatableConditionType =>
  CHANNEL_MARKUP_CREATABLE_CONDITION_TYPES.includes(conditionType as ChannelMarkupCreatableConditionType);
